import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    add: 'Create a new document',
    createInvoice: 'Create an invoice',
    createQuote: 'Create a quote',
    invoices: 'Invoices',
    quotes: 'Quotes',
  },
  fr: {
    add: 'Créer un nouveau document',
    createInvoice: 'Créer une facture',
    createQuote: 'Créer un devis',
    invoices: 'Factures',
    quotes: 'Devis',
  },
} as const);

export default locales;
